import { Component, Inject, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialog } from '@angular/material/dialog';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';

@Component({
  selector: 'app-oven-job-list',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatExpansionModule
  ],
  templateUrl: './oven-job-list.component.html',
  styleUrl: './oven-job-list.component.scss'
})
export class OvenJobListComponent implements OnInit {
  public baseOvenUrl = BaseUrlConstantsService.OVEN_BASE_URL;
  public dataSource: any = [];
  public measurementsDataSource: any = [];
  public displayedColumns: string[] = [
    'jobNumber',
    'sensors',
    'startDate',
    'endDate',
    'meggerValue',
    'piValue',
    'sensorSerial1',
    'sensorSerial1Value',
    'sensorSerial2',
    'sensorSerial2Value',
    'sensorSerial3',
    'sensorSerial3Value',
    'supervisor',
    'status',
    'expand'
  ];
  public measurementsColumns: string[] = ['meggerValue', 'piValue', 'supervisor', 'dateTime'];
  public clientId: number;
  public ovenId: number;
  public isLoadingMeasurements: boolean = false;
  public expandedJobId: string | null = null;

  @ViewChild('measurementsDialog') measurementsDialog: TemplateRef<any>;

  constructor(
    private dialogRef: MatDialogRef<OvenJobListComponent>,
    public service: BackendApiService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.clientId = data['clientId'];
    this.ovenId = data['ovenId'];
  }

  ngOnInit() {
    this.getJobData();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getJobData() {
    console.log('Fetching job data for clientId:', this.clientId, 'ovenId:', this.ovenId);
    
    this.service.getData(`${this.baseOvenUrl}api/v1/oven-assets/jobs/get/All/${this.clientId}/${this.ovenId}`)
      .then((res: any) => {
        console.log('Job data response:', res);
        if (res.code === 200) {
          this.dataSource = res.data;
          console.log('DataSource updated:', this.dataSource);
        }
      })
      .catch((error: any) => {
        console.error('Error fetching job data:', error);
      });
  }

  toggleMeasurements(jobNumber: string) {
    console.log('Toggle measurements for:', jobNumber);
    if (this.expandedJobId === jobNumber) {
      this.expandedJobId = null;
    } else {
      this.expandedJobId = jobNumber;
      this.fetchMeasurements(jobNumber);
    }
  }

  fetchMeasurements(jobNumber: string) {
    this.isLoadingMeasurements = true;
    this.measurementsDataSource = [];
    
    const body = {
      client_id: this.clientId,
      job_id: jobNumber
    };

    // console.log('Fetching measurements with body:', body);
    this.service.postData(`${this.baseOvenUrl}/api/v1/oven-assets/jobs/all-measurments`, body)
    // this.service.postData('http://localhost:3024/api/v1/oven-assets/jobs/all-measurments', body)
      .then((res: any) => {
        console.log('Measurements response:', res);
        if (res?.data && Array.isArray(res.data)) {
          this.measurementsDataSource = res.data;
        } else if (res?.data && typeof res.data === 'object') {
          this.measurementsDataSource = [res.data];
        } else {
          this.measurementsDataSource = [];
        }
        this.isLoadingMeasurements = false;
        console.log('MeasurementsDataSource updated:', this.measurementsDataSource);
      })
      .catch((error: any) => {
        console.error('Error fetching measurements:', error);
        this.measurementsDataSource = [];
        this.isLoadingMeasurements = false;
      });
  }

  isMeasurementExpanded(jobNumber: string): boolean {
    return this.expandedJobId === jobNumber;
  }

  openMeasurementsDialog(jobNumber: string) {
    this.fetchMeasurements(jobNumber);
    this.dialog.open(this.measurementsDialog, {
      width: '900px',
      maxWidth: '95vw',
      disableClose: false,
      panelClass: 'measurements-dialog'
    });
  }

  isDetailRow = (index: number, element: any): boolean => {
    const result = this.isMeasurementExpanded(element.JOB_NO);
    if (result) {
      console.log('Detail row showing for:', element.JOB_NO);
    }
    return result;
  }
}